var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        value: _vm.open,
        "content-class": "request-field-item-dialog",
        persistent: ""
      }
    },
    [
      _c(
        "v-card",
        {
          staticClass: "home-form-container",
          staticStyle: {
            "min-height": "180px",
            "max-height": "600px",
            "padding-top": "15px"
          },
          attrs: { color: "#f0f0ef" }
        },
        [
          _c(
            "v-card-text",
            {
              staticClass: "home-form-container",
              staticStyle: { "max-height": "600px", "overflow-y": "visible" }
            },
            [
              _c(
                "div",
                { staticStyle: { width: "100px", "text-align": "left" } },
                [
                  _c(
                    "label",
                    {
                      staticStyle: {
                        "font-size": "14px",
                        "margin-right": "30px"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$tc("Add")))]
                  )
                ]
              ),
              _vm._v(" "),
              _c("drop-file-area", {
                ref: "dropFileArea",
                staticStyle: { "margin-top": "10px", "max-height": "400px" },
                style: _vm.dropFileAreaStyle,
                attrs: {
                  disabled: false,
                  "file-types": _vm.acceptedFileTypes,
                  multipleFiles: _vm.allowMultipleFiles
                },
                on: {
                  updateFile: function($event) {
                    _vm.importFile = $event
                  },
                  trashFile: function($event) {
                    _vm.importFile = null
                  }
                }
              }),
              _vm._v(" "),
              _vm._t("formSlot1"),
              _vm._v(" "),
              _c(
                "v-card-actions",
                { staticStyle: { padding: "20px 0 0 0" } },
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c("management-button", {
                    attrs: { type: "cancel", label: _vm.$t("Cancel") },
                    on: { buttonClick: _vm.close }
                  }),
                  _vm._v(" "),
                  _c("management-button", {
                    attrs: {
                      type: "execute",
                      label: _vm.$t("Create"),
                      disabled: _vm.submitButtonDisabled
                    },
                    on: { buttonClick: _vm.saveAttachment }
                  })
                ],
                1
              )
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6aac4444", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6aac4444","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Support/TechnicalSupport/AttachmentForm.vue
// module id = null
// module chunks = 